import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const countriesSchema: CollectionCreateSchema = {
  name: CollectionName.Countries,
  fields: [
    {
      name: "alpha_2_code",
      type: "string",
      infix: true,
      sort: true,
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "name",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "subregion",
      type: "string",
      facet: true,
      sort: true,
      infix: true,
    },
    {
      name: "region",
      type: "string",
      facet: true,
      sort: true,
      infix: true,
    },
    {
      name: "short_name_en",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "active",
      type: "bool",
      optional: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
